export function splitSlotId(slotId: string) {
  const [siteId, visitId] = slotId.split("_");

  return { siteId, visitId };
}
